import QuoteStore from '@ncl/modules/quote/store/QuoteStore';
import AccountStore from '@ncl/modules/account/store/AccountStore';

export function initApi(setReady, attempts = 0) {
  if (attempts >= 3) return;

  if (!window.zE) {
    setTimeout(() => {
      initApi(setReady, attempts + 1);
    }, 1000);
  } else {
    setReady(true);
  }
}

export function updateZIndex() {
  window.zE('webWidget', 'updateSettings', {
    webWidget: {
      zIndex: 99990,
    },
  });
}

export function identifyLead() {
  const { Lead } = QuoteStore;
  const { currentUser } = AccountStore;

  if (!Lead.nomeContato && !currentUser.displayName) return;
  const { nomeContato, telefone, email } = Lead;

  window.zE('webWidget', 'prefill', {
    name: {
      value: nomeContato || '',
    },
    email: {
      value: currentUser.email || email,
    },
    phone: {
      value: telefone || '',
    },
  });
}
